import { Navigate } from "react-router-dom";

//Dashboard
import DashboardCrm from "../pages/Dashboard";

//pages
import ComingSoon from '../pages/Pages/ComingSoon/ComingSoon';
import Settings from '../pages/Pages/Profile/Settings/Settings';

//login
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";

import UserList from "pages/User/User";

import CategoryList from "pages/Category";

import OperatorList from "pages/Operator/Operator";
import Profile from "pages/Operator/Profile";
import RoleList from "pages/Operator/Role";

import AINewsList from "pages/News/AINews";

import ImageBasedNewsList from "pages/News/GovernmentNews/ImageBasedNews";
import LogoBasedNewsList from "pages/News/GovernmentNews/LogoBasedNews";


import ConfigurationAINews from "pages/Configuration/AINews";
import ConfigurationGovernmentNews from "pages/Configuration/GovernmentNews";
import ConfigurationAICustomNews from "pages/Configuration/AICustomNews";
import ConfigurationAICustomRealTimeKeyword from "pages/Configuration/AICustomRealTimeKeywordUser";
import ConfigurationAICustomPopularKeyword from "pages/Configuration/AICustomPopularKeywordUser";
import ConfigurationBoostingNews from "pages/Configuration/BoostingNews";
import ConfigurationBoostingNewsv2 from "pages/Configuration/BoostingNewsv2";
import ConfigurationBoostingNewsTravel from "pages/Configuration/BoostingNewsTravel";
import ConfigurationBoostingNewsWeather from "pages/Configuration/BoostingNewsWeather";
import ConfigurationBoostingNewsWeatherWarning from "pages/Configuration/BoostingNewsWeatherWarning";
import ConfigurationBoostingNewsStock from "pages/Configuration/BoostingNewsStock";
import ConfigurationBoostingNewsTossStock from "pages/Configuration/BoostingNewsTossStock";
import ConfigurationAppTech from "pages/Configuration/AppTech";
import ConfigurationRealTimeNews from "pages/Configuration/RealTimeNews";
import ConfigurationTaskKeyword from "pages/Configuration/TaskKeyword";
import ConfigurationRealKeyword from "pages/Configuration/RealKeyword";
import ExtractDailySearchVolume from "pages/ExtractDailySearchVolume";
import JournalistList from "pages/Journalist";
import KeywordBoostV2List from "pages/KeywordBoostV2";
import KeywordGoldenList from "pages/KeywordGolden";
import KeywordTaskList from "pages/KeywordTask";
import KeywordExcludeList from "pages/KeywordExclude";
import KeywordNaverList from "pages/KeywordNaver";
import MailLog from "pages/Mail/MailLog";
import MailStatistic from "pages/Mail/MailStatistic";
import BoostingNewsList from "pages/News/BoostingNews";
import GeneralNewsList from "pages/News/GenerateNews/GeneralNewsList";
import GenerateNamuwikiNewsList from "pages/News/GenerateNews/GenerateNamuwikiNewsList";
import GenerateNaverNewsList from "pages/News/GenerateNews/GenerateNaverNewsList";
import GenerateCarNewsList from "pages/News/GenerateNews/GeneralCarNewsList";
import GenerateNewsV2 from "pages/News/GenerateNews/GenerateNewsV2";
import RealTimeNewsList from "pages/News/RealTimeNews";
import ActivityLogList from "pages/Operator/ActivityLog";
import KeywordRealTime from "pages/KeywordRealTime";
import GoogleImage from "pages/Image/Google";
import LibraryImage from "pages/Image/Library";
import PublicImage from "pages/Image/Public";
import TrackingNewsList from "pages/News/TrackingNews";
import Log from "pages/Log/TrackingLog";
import DailyStatistic from "pages/Statistics/DailyStatistic";
import KeywordRealTimeStatistic from "pages/Statistics/KeywordRealTimeStatistic";
import KeywordPublishedStatistic from "pages/Statistics/KeywordPublishedStatistic";
import MediaStatistic from "pages/Statistics/MediaStatistic";
import CampaignCarList from "pages/Car/Campaign";
import BoostingContentList from "pages/News/BoostingContent";
import Car from "pages/Car";
import SurvivalStatistic from "pages/Statistics/SurvivalStatistic";
import HourlyStatistic from "pages/Statistics/HourlyStatistic";
import AppTech from "pages/AppTech";
import ApprovedArticleStatistic from "pages/Statistics/ApprovedArticleStatistic";
import GoldPrice from "pages/GoldPrice";
import Vote from "pages/Vote";
import VoteKeyword from "pages/VoteKeyword";
import NewsRecomposition from "pages/NewsRecomposition";
import NewsStock from "pages/NewsStock";
import NewsTossStock from "pages/NewsTossStock";
import CategoryStatistic from "pages/Statistics/CategoryStatistic";


import NewsHubMedia from "pages/NewsHub/Media/Media";
import NewsHubCampaign from "pages/NewsHub/Campaign/CampaignList";
import NewsHubNews from "pages/NewsHub/News";
import GenerateTravelNews from "pages/News/GenerateNews/GenerateTravelNews";
import GenerateWeatherNews from "pages/News/GenerateNews/GenerateWeatherNews";
import GenerateWeatherWarningNews from "pages/News/GenerateNews/GenerateWeatherWarningNews";
import GenerateStockNews from "pages/News/GenerateNews/GenerateStockNews";
import NewsTravel from "pages/NewsTravel";
import NewsWeather from "pages/NewsWeather";
import NewsWeatherWarning from "pages/NewsWeatherWarning";


const ROUTES = {
  LOGIN: "/login",
  LOGOUT: "/logout",

  HOME: '/',
  DASHBOARD: '/dashboard',

  PROFILE: '/profile',
  PROFILE_SETTING: '/pages-profile-settings',

  USER_LIST: '/user/list',

  CATEGORY_LIST: '/category',

  AI_NEWS: '/ai-news',

  IMAGE_BASED_NEWS: '/government-news/image-based-news',

  LOGO_BASED_NEWS: '/government-news/logo-based-news',

  BOOSTING_NEWS: '/boosting-news',

  // KEYWORD_BOOST_LIST: '/boosting-keyword-v1',

  KEYWORD_BOOST_V2_LIST: '/boosting-keyword',

  KEYWORD_GOLDEN_LIST: '/golden-keyword',

  KEYWORD_TASK_LIST: '/task-keyword',

  KEYWORD_EXCLUDE_LIST: '/exclude-keyword',

  KEYWORD_NAVER_LIST: '/naver-news-keyword',

  REAL_TIME_NEWS: '/real-time-news',

  KEYWORD_REAL_TIME: '/real-time-keyword',

  BOOSTING_CONTENT_NEWS: '/boosting-content',

  CAR: '/boosting-content/car',
  APP_TECH: '/boosting-content/app-tech',
  GOLD_PRICE: '/boosting-content/gold-price',
  VOTE: '/boosting-content/vote',
  VOTE_KEYWORD: '/boosting-content/vote-keyword',
  NEWS_RECOMPOSITION: '/boosting-content/news-recomposition',

  NEWS_TRAVEL: '/boosting-content/news-travel',
  NEWS_WEATHER: '/boosting-content/news-weather',
  NEWS_WEATHER_WARNING: '/boosting-content/news-weather-warning',

  NEWS_STOCK: '/boosting-content/news-stock',
  NEWS_TOSS_STOCK: '/boosting-content/news-toss-stock',

  ARTICLE_TRACKING: '/article-tracking',

  JOURNALIST_LIST: '/sending-email',

  GENERAL_NEWS_LIST: '/general-simulator',

  GENERATE_NEWS_LIST: '/news-simulator',

  GENERATE_NAMUWIKI_NEWS_LIST: '/namuwiki-simulator',

  GENERATE_CAR_NEWS_LIST: '/car-simulator',

  EXTRACT_DAILY_SEARCH_VOLUME: '/extract-daily-search-volume',

  GENERATE_NEWS_V2_LIST: '/news-v2-simulator',

  GENERATE_NEWS_TRAVEL_LIST: '/news-travel-simulator',

  GENERATE_NEWS_WEATHER_LIST: '/news-weather-simulator',

  GENERATE_NEWS_WEATHER_WARNING_LIST: '/news-weather-warning-simulator',

  GENERATE_NEWS_STOCK_LIST: '/news-stock-simulator',

  MAIL_LOG: '/email-logs',

  MAIL_STATISTICS: '/email-statistics',

  LOG: '/statistics/log',

  DAILY_STATISTICS: '/statistics/daily-statistics',
  HOURLY_STATISTICS: '/statistics/hourly-statistics',
  KEYWORD_STATISTICS: '/statistics/keyword-statistics',
  KEYWORD_REAL_TIME_STATISTICS: '/statistics/keyword-statistics',
  KEYWORD_PUBLISHED_STATISTICS: '/statistics/cumulative-statistics',
  CATEGORY_STATISTICS: '/statistics/category-statistics',
  MEDIA_STATISTICS: '/statistics/media-statistics',
  SURVIVAL_STATISTICS: '/statistics/survival-statistics',
  APPROVED_ARTICLE_STATISTICS: '/statistics/approved-article-statistics',

  CONFIGURATION_AI_NEWS: '/configuration/ai-news',
  CONFIGURATION_BOOSTING_NEWS: '/configuration/boosting-news',
  CONFIGURATION_BOOSTING_NEWS_V2: '/configuration/boosting-news-v2',
  CONFIGURATION_REAL_TIME_NEWS: '/configuration/real-time-news',
  CONFIGURATION_BOOSTING_NEWS_TRAVEL: '/configuration/boosting-news-travel',
  CONFIGURATION_GOVERNMENT_NEWS: '/configuration/government-news',
  CONFIGURATION_BOOSTING_NEWS_WEATHER: '/configuration/boosting-news-weather',
  CONFIGURATION_BOOSTING_NEWS_WEATHER_WARNING: '/configuration/boosting-news-weather-warning',
  CONFIGURATION_BOOSTING_NEWS_STOCK: '/configuration/boosting-news-stock',
  CONFIGURATION_BOOSTING_NEWS_TOSS_STOCK: '/configuration/boosting-news-toss-stock',
  CONFIGURATION_APP_TECH: '/configuration/app-tech',
  CONFIGURATION_TASK_KEYWORD: '/configuration/keyword-task',
  CONFIGURATION_REAL_KEYWORD: '/configuration/keyword-real',
  CONFIGURATION_AI_CUSTOM_NEWS: '/configuration/ai-article-creation',
  CONFIGURATION_REAL_TIME_KEYWORD_USER: '/configuration/realtime-keyword-user',
  CONFIGURATION_POPULAR_KEYWORD_USER: '/configuration/popular-keyword-user',

  OPERATOR_LIST: '/operator/list',
  OPERATOR_ROLE: '/operator/role',
  OPERATOR_ACTIVITY_LOG: '/operator/activity-logs',
  OPERATOR_PROFILE: '/operator/profile',

  GOOGLE_IMAGE_LIST: '/image-management/google-image',
  IMAGE_LIBRARY_LIST: '/image-management/custom-image',
  IMAGE_PUBLIC_LIST: '/image-management/public-image',

  NEWSHUB_MEDIA: '/newshub/media',
  NEWSHUB_CAMPAIGN: '/newshub/campaign',
  NEWSHUB_NEWS: '/newshub/news'

}

const ROUTE_NAMES = [
  {
    link: ROUTES.LOGIN,
    name: "Login",
  },
  // {
  //   link: ROUTES.LOGOUT,
  //   name: 'Log Out'
  // },
  {
    link: ROUTES.DASHBOARD,
    name: "Dashboards",
  },
  {
    link: ROUTES.PROFILE,
    name: "Profile",
  },
  {
    link: ROUTES.USER_LIST,
    name: "User Management",
  },
  {
    link: ROUTES.CATEGORY_LIST,
    name: "Category Management",
  },
  {
    link: ROUTES.AI_NEWS,
    name: "AI News",
  },
  {
    link: ROUTES.IMAGE_BASED_NEWS,
    name: "Image Based News",
  },
  {
    link: ROUTES.LOGO_BASED_NEWS,
    name: "Logo Based News",
  },
  {
    link: ROUTES.BOOSTING_NEWS,
    name: "Boosting News",
  },
  // {
  //   link: ROUTES.KEYWORD_BOOST_LIST,
  //   name: "Boosting Keywords",
  // },
  {
    link: ROUTES.KEYWORD_BOOST_V2_LIST,
    name: "Boosting Keyword",
  },
  {
    link: ROUTES.KEYWORD_GOLDEN_LIST,
    name: "Golden Keyword",
  },
  {
    link: ROUTES.KEYWORD_TASK_LIST,
    name: "Task Keyword",
  },
  {
    link: ROUTES.KEYWORD_EXCLUDE_LIST,
    name: "Exclude Keyword",
  },
  {
    link: ROUTES.KEYWORD_NAVER_LIST,
    name: "Naver News Keywords",
  },
  {
    link: ROUTES.REAL_TIME_NEWS,
    name: "Real-Time News",
  },
  {
    link: ROUTES.KEYWORD_REAL_TIME,
    name: "Real-Time Keyword",
  },
  {
    link: ROUTES.BOOSTING_CONTENT_NEWS,
    name: "Boosting Content",
  },
  {
    link: ROUTES.CAR,
    name: "Car",
  },
  {
    link: ROUTES.APP_TECH,
    name: "AppTech",
  },
  {
    link: ROUTES.GOLD_PRICE,
    name: "Gold Prices",
  },
  {
    link: ROUTES.VOTE,
    name: "Vote",
  },
  {
    link: ROUTES.VOTE_KEYWORD,
    name: "Vote Keyword",
  },
  {
    link: ROUTES.NEWS_RECOMPOSITION,
    name: "News Recomposition",
  },
  {
    link: ROUTES.NEWS_TRAVEL,
    name: "News Travel",
  },
  {
    link: ROUTES.NEWS_WEATHER,
    name: "News Weather",
  },
  {
    link: ROUTES.NEWS_WEATHER_WARNING,
    name: "News Weather Warning",
  },
  {
    link: ROUTES.NEWS_STOCK,
    name: "News Stock",
  },
  {
    link: ROUTES.NEWS_TOSS_STOCK,
    name: "News Toss Stock",
  },
  {
    link: ROUTES.ARTICLE_TRACKING,
    name: "News Monitor",
  },
  {
    link: ROUTES.JOURNALIST_LIST,
    name: "Sending Email",
  },
  {
    link: ROUTES.GENERAL_NEWS_LIST,
    name: "General Simulator",
  },
  {
    link: ROUTES.GENERATE_NEWS_LIST,
    name: "News Simulator",
  },
  {
    link: ROUTES.GENERATE_NAMUWIKI_NEWS_LIST,
    name: "Namuwiki Simulator",
  },
  {
    link: ROUTES.GENERATE_NEWS_V2_LIST,
    name: "News V2 Simulator",
  },
  {
    link: ROUTES.GENERATE_NEWS_TRAVEL_LIST,
    name: "Travel News Simulator",
  },
  {
    link: ROUTES.GENERATE_NEWS_WEATHER_LIST,
    name: "Weather News Simulator",
  },
  {
    link: ROUTES.GENERATE_NEWS_WEATHER_WARNING_LIST,
    name: "Weather Warning News Simulator",
  },
  {
    link: ROUTES.GENERATE_NEWS_STOCK_LIST,
    name: "Stock News Simulator",
  },
  {
    link: ROUTES.EXTRACT_DAILY_SEARCH_VOLUME,
    name: "Extract Daily Search Volume",
  },
  {
    link: ROUTES.MAIL_LOG,
    name: "Email Log",
  },
  {
    link: ROUTES.MAIL_STATISTICS,
    name: "Email Statistics",
  },
  {
    link: ROUTES.LOG,
    name: "Log",
  },
  {
    link: ROUTES.DAILY_STATISTICS,
    name: "Daily Statistics",
  },
  {
    link: ROUTES.HOURLY_STATISTICS,
    name: "Hourly Statistics",
  },
  {
    link: ROUTES.SURVIVAL_STATISTICS,
    name: "Survival Statistics",
  },
  {
    link: ROUTES.APPROVED_ARTICLE_STATISTICS,
    name: "Approved Article Statistics",
  },
  {
    link: ROUTES.KEYWORD_STATISTICS,
    name: "Keyword Statistics",
  },
  {
    link: ROUTES.KEYWORD_REAL_TIME_STATISTICS,
    name: "Keyword Statistics (Real-time)",
  },
  {
    link: ROUTES.KEYWORD_PUBLISHED_STATISTICS,
    name: "Keyword Statistics (Published)",
  },
  {
    link: ROUTES.CATEGORY_STATISTICS,
    name: "Category Statistics",
  },
  {
    link: ROUTES.MEDIA_STATISTICS,
    name: "Media Statistics",
  },
  {
    link: ROUTES.OPERATOR_LIST,
    name: "Operator",
  },
  {
    link: ROUTES.OPERATOR_ROLE,
    name: "Role",
  },
  {
    link: ROUTES.OPERATOR_ACTIVITY_LOG,
    name: "Activity Logs",
  },
  {
    link: ROUTES.CONFIGURATION_AI_NEWS,
    name: "AI News",
  },
  {
    link: ROUTES.CONFIGURATION_GOVERNMENT_NEWS,
    name: "Government News",
  },
  {
    link: ROUTES.CONFIGURATION_AI_CUSTOM_NEWS,
    name: "AI Article Creation (User)",
  },
  {
    link: ROUTES.CONFIGURATION_REAL_TIME_KEYWORD_USER,
    name: "Real-time Keyword (User)",
  },
  {
    link: ROUTES.CONFIGURATION_POPULAR_KEYWORD_USER,
    name: "Popular Keyword (User)",
  },
  {
    link: ROUTES.CONFIGURATION_BOOSTING_NEWS,
    name: "Boosting News",
  },
  {
    link: ROUTES.CONFIGURATION_BOOSTING_NEWS_V2,
    name: "Boosting News v2",
  },
  {
    link: ROUTES.CONFIGURATION_BOOSTING_NEWS_TRAVEL,
    name: "Boosting News Travel",
  },
  {
    link: ROUTES.CONFIGURATION_BOOSTING_NEWS_WEATHER,
    name: "Boosting News Weather",
  },
  {
    link: ROUTES.CONFIGURATION_BOOSTING_NEWS_WEATHER_WARNING,
    name: "Boosting News Weather Warning",
  },
  {
    link: ROUTES.CONFIGURATION_BOOSTING_NEWS_STOCK,
    name: "Boosting News Stock",
  },
  {
    link: ROUTES.CONFIGURATION_BOOSTING_NEWS_TOSS_STOCK,
    name: "Boosting News Toss Stock",
  },
  {
    link: ROUTES.CONFIGURATION_APP_TECH,
    name: "AppTech",
  },
  {
    link: ROUTES.CONFIGURATION_TASK_KEYWORD,
    name: "Task Keyword",
  },
  {
    link: ROUTES.CONFIGURATION_REAL_KEYWORD,
    name: "Real Time Keyword",
  },
  {
    link: ROUTES.CONFIGURATION_REAL_TIME_NEWS,
    name: "Real-Time News",
  },
  {
    link: ROUTES.GOOGLE_IMAGE_LIST,
    name: "Google Image",
  },
  {
    link: ROUTES.IMAGE_LIBRARY_LIST,
    name: "Custom Image",
  },
  {
    link: ROUTES.IMAGE_PUBLIC_LIST,
    name: "Public Image",
  },
  {
    link: ROUTES.NEWSHUB_MEDIA,
    name: "Media",
  },
  {
    link: ROUTES.NEWSHUB_CAMPAIGN,
    name: "Campaign",
  },
  {
    link: ROUTES.NEWSHUB_NEWS,
    name: "News",
  },
];

const authProtectedRoutes = [
  { path: ROUTES.DASHBOARD, component: <DashboardCrm /> },

  { path: ROUTES.PROFILE_SETTING, component: <Settings /> },
  { path: ROUTES.PROFILE, component: <UserProfile /> },

  { path: ROUTES.USER_LIST, component: <UserList /> },

  { path: ROUTES.CATEGORY_LIST, component: <CategoryList /> },

  { path: ROUTES.AI_NEWS, component: <AINewsList /> },

  { path: ROUTES.IMAGE_BASED_NEWS, component: <ImageBasedNewsList /> },
  { path: ROUTES.LOGO_BASED_NEWS, component: <LogoBasedNewsList /> },

  { path: ROUTES.BOOSTING_NEWS, component: <BoostingNewsList /> },

  { path: ROUTES.ARTICLE_TRACKING, component: <TrackingNewsList /> },

  // { path: ROUTES.KEYWORD_BOOST_LIST, component: <KeywordBoostList /> },

  { path: ROUTES.KEYWORD_BOOST_V2_LIST, component: <KeywordBoostV2List /> },

  { path: ROUTES.KEYWORD_GOLDEN_LIST, component: <KeywordGoldenList /> },

  { path: ROUTES.KEYWORD_TASK_LIST, component: <KeywordTaskList /> },

  { path: ROUTES.KEYWORD_EXCLUDE_LIST, component: <KeywordExcludeList /> },

  { path: ROUTES.KEYWORD_NAVER_LIST, component: <KeywordNaverList /> },

  { path: ROUTES.REAL_TIME_NEWS, component: <RealTimeNewsList /> },

  { path: ROUTES.CAR, component: <Car /> },

  { path: ROUTES.APP_TECH, component: <AppTech /> },

  { path: ROUTES.GOLD_PRICE, component: <GoldPrice /> },

  { path: ROUTES.VOTE, component: <Vote /> },

  { path: ROUTES.VOTE_KEYWORD, component: <VoteKeyword /> },

  { path: ROUTES.NEWS_RECOMPOSITION, component: <NewsRecomposition /> },

  { path: ROUTES.NEWS_TRAVEL, component: <NewsTravel /> },

  { path: ROUTES.NEWS_WEATHER, component: <NewsWeather /> },

  { path: ROUTES.NEWS_WEATHER_WARNING, component: <NewsWeatherWarning /> },

  { path: ROUTES.NEWS_STOCK, component: <NewsStock /> },

  { path: ROUTES.NEWS_TOSS_STOCK, component: <NewsTossStock /> },

  { path: ROUTES.BOOSTING_CONTENT_NEWS, component: <BoostingContentList /> },

  { path: ROUTES.KEYWORD_REAL_TIME, component: <KeywordRealTime /> },

  { path: ROUTES.JOURNALIST_LIST, component: <JournalistList /> },

  { path: ROUTES.GENERATE_NEWS_LIST, component: <GenerateNaverNewsList /> },

  { path: ROUTES.GENERAL_NEWS_LIST, component: <GeneralNewsList /> },

  { path: ROUTES.GENERATE_NAMUWIKI_NEWS_LIST, component: <GenerateNamuwikiNewsList /> },

  { path: ROUTES.GENERATE_NEWS_V2_LIST, component: <GenerateNewsV2 /> },

  { path: ROUTES.GENERATE_NEWS_TRAVEL_LIST, component: <GenerateTravelNews /> },

  { path: ROUTES.GENERATE_NEWS_WEATHER_LIST, component: <GenerateWeatherNews /> },

  { path: ROUTES.GENERATE_NEWS_WEATHER_WARNING_LIST, component: <GenerateWeatherWarningNews /> },

  { path: ROUTES.GENERATE_NEWS_STOCK_LIST, component: <GenerateStockNews /> },

  { path: ROUTES.GENERATE_CAR_NEWS_LIST, component: <GenerateCarNewsList /> },

  { path: ROUTES.EXTRACT_DAILY_SEARCH_VOLUME, component: <ExtractDailySearchVolume /> },

  { path: ROUTES.MAIL_LOG, component: <MailLog /> },

  { path: ROUTES.MAIL_STATISTICS, component: <MailStatistic /> },

  { path: ROUTES.LOG, component: <Log /> },
  { path: ROUTES.DAILY_STATISTICS, component: <DailyStatistic /> },
  { path: ROUTES.HOURLY_STATISTICS, component: <HourlyStatistic /> },
  { path: ROUTES.SURVIVAL_STATISTICS, component: <SurvivalStatistic /> },
  { path: ROUTES.APPROVED_ARTICLE_STATISTICS, component: <ApprovedArticleStatistic /> },
  { path: ROUTES.KEYWORD_REAL_TIME_STATISTICS, component: <KeywordRealTimeStatistic /> },
  { path: ROUTES.KEYWORD_PUBLISHED_STATISTICS, component: <KeywordPublishedStatistic /> },
  { path: ROUTES.CATEGORY_STATISTICS, component: <CategoryStatistic /> },
  { path: ROUTES.MEDIA_STATISTICS, component: <MediaStatistic /> },

  { path: ROUTES.OPERATOR_LIST, component: <OperatorList /> },
  { path: ROUTES.OPERATOR_ROLE, component: <RoleList /> },
  { path: ROUTES.OPERATOR_ACTIVITY_LOG, component: <ActivityLogList /> },
  { path: ROUTES.OPERATOR_PROFILE, component: <Profile /> },

  { path: ROUTES.CONFIGURATION_AI_NEWS, component: <ConfigurationAINews /> },
  { path: ROUTES.CONFIGURATION_GOVERNMENT_NEWS, component: <ConfigurationGovernmentNews /> },
  { path: ROUTES.CONFIGURATION_AI_CUSTOM_NEWS, component: <ConfigurationAICustomNews /> },
  { path: ROUTES.CONFIGURATION_REAL_TIME_KEYWORD_USER, component: <ConfigurationAICustomRealTimeKeyword /> },
  { path: ROUTES.CONFIGURATION_POPULAR_KEYWORD_USER, component: <ConfigurationAICustomPopularKeyword /> },
  { path: ROUTES.CONFIGURATION_BOOSTING_NEWS, component: <ConfigurationBoostingNews /> },
  { path: ROUTES.CONFIGURATION_BOOSTING_NEWS_V2, component: <ConfigurationBoostingNewsv2 /> },
  { path: ROUTES.CONFIGURATION_BOOSTING_NEWS_TRAVEL, component: <ConfigurationBoostingNewsTravel /> },
  { path: ROUTES.CONFIGURATION_BOOSTING_NEWS_WEATHER, component: <ConfigurationBoostingNewsWeather /> },
  { path: ROUTES.CONFIGURATION_BOOSTING_NEWS_WEATHER_WARNING, component: <ConfigurationBoostingNewsWeatherWarning /> },
  { path: ROUTES.CONFIGURATION_BOOSTING_NEWS_STOCK, component: <ConfigurationBoostingNewsStock /> },
  { path: ROUTES.CONFIGURATION_BOOSTING_NEWS_TOSS_STOCK, component: <ConfigurationBoostingNewsTossStock /> },
  { path: ROUTES.CONFIGURATION_APP_TECH, component: <ConfigurationAppTech /> },
  { path: ROUTES.CONFIGURATION_REAL_TIME_NEWS, component: <ConfigurationRealTimeNews /> },
  { path: ROUTES.CONFIGURATION_TASK_KEYWORD, component: <ConfigurationTaskKeyword /> },
  { path: ROUTES.CONFIGURATION_REAL_KEYWORD, component: <ConfigurationRealKeyword /> },

  { path: ROUTES.GOOGLE_IMAGE_LIST, component: <GoogleImage /> },
  { path: ROUTES.IMAGE_LIBRARY_LIST, component: <LibraryImage /> },
  { path: ROUTES.IMAGE_PUBLIC_LIST, component: <PublicImage /> },

  { path: ROUTES.NEWSHUB_MEDIA, component: <NewsHubMedia /> },
  { path: ROUTES.NEWSHUB_CAMPAIGN, component: <NewsHubCampaign /> },
  { path: ROUTES.NEWSHUB_NEWS, component: <NewsHubNews /> },


  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to={ROUTES.DASHBOARD} />,
  },
  { path: "*", component: <Navigate to={ROUTES.DASHBOARD} /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },

  //AuthenticationInner pages
  { path: "/pages-coming-soon", component: <ComingSoon /> },
];

export { authProtectedRoutes, publicRoutes, ROUTE_NAMES, ROUTES };

